import { ViewOpts } from '@play-co/timestep-core/ui';
import { spineLoader } from '@play-co/timestep-spine';
import SpineAnimationView from 'src/game/components/shared/SpineAnimationView';
import gsap from 'gsap';

export const streakCloudPlatformAssets = {
  loadMethod: spineLoader,
  url: 'assets/ui/match2/streakbattleroyaleV2/spines/platform/spine.mtfuji.platform',
};

type AnimationId = 'idle' | 'destroyed';

const idleDuration = 2;

export default class StreakCloudPlatform extends SpineAnimationView {
  private currentAnimation!: AnimationId;
  private _idleRatio = 0;

  public get idleRatio() {
    return this._idleRatio / idleDuration;
  }

  constructor(opts: ViewOpts, idleOffset?: number) {
    super({
      ...opts,
      spinePath: streakCloudPlatformAssets.url,
    });

    this.idle(idleOffset);
  }

  public idle(offset = 0) {
    if (this.currentAnimation === 'idle') {
      return;
    }

    this.currentAnimation = 'idle';

    gsap.killTweensOf(this.style);
    this.style.opacity = 1;
    this.style.visible = true;

    this.start({ id: 'idle', loop: true, offset });

    this._idleRatio = offset;
  }

  public async destroy(instant = false) {
    this.currentAnimation = 'destroyed';

    if (instant) {
      this.style.opacity = 0;
      this.style.visible = false;
      return;
    }

    this.start({ id: 'destroyed' });

    // TODO: Not sure why the animation doesn't seem to play to the end where the cloud bits are alpha-ed out,
    // so manual alpha tween is applied here as a workaround.
    await gsap.to(this.style, {
      duration: 0.4,
      opacity: 0,
      ease: 'quad.in',
    });

    this.style.visible = false;
  }

  public tick(dt: number): void {
    super.tick(dt);

    if (this.currentAnimation === 'idle') {
      this._idleRatio += dt / 1000;
      this._idleRatio %= idleDuration;
    }
  }
}
